export default {
  minHeight: 35,
  minWidth: 155,
  height: 35,
  margin: 2
}



// WEBPACK FOOTER //
// ./src/styles/buttons/fixedHeight.js